export default {"src":"/_next/static/media/white-apps.6a0d15e8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};